import React from "react";
import { Skeleton } from "@heroui/skeleton";

export default function BoxSkeletonFinancials() {
  return (
    <Skeleton className="space-y-4 mt-4 h-250 mb-4 rounded-lg">
      <Skeleton className="h-20 w-full mb-4 rounded-lg" />
      <Skeleton className="h-20 w-full mb-4 rounded-lg" />
    </Skeleton>
  );
}
